module.exports = __webpack_public_path__ + "static/media/astroPay.4fe1d470.svg";